import * as React from 'react';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { isPartialDate, sortPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import { useIntl } from 'react-intl';
import { filterByDocumentType } from 'Utility/documentHandling';
import PlatformConditional from 'Components/PlatformConditional';

const ProceduresDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });

  const procedureDocs = filterByDocumentType(documents, 'procedure');

  const plasmaChangeDocs = procedureDocs
    .filter(d => d.code?.code === '19647005')
    .sort((d1, d2) => sortPartialDate(d2.date, d1.date));
  const thymectomyDocs = procedureDocs
    .filter(d => d.code?.code === '399750009')
    .sort((d1, d2) => sortPartialDate(d2.date, d1.date));

  return (
    <>
      <PlatformConditional platform={'mgravis'}>
        <TileContentMaker
          type="specificListNoDate"
          data={[
            ...(plasmaChangeDocs.length > 0
              ? [
                  {
                    value: isPartialDate(plasmaChangeDocs[0]?.date) ? formatPartialDate(plasmaChangeDocs[0].date) : '',
                    title: fm('procedure.latestPlasmaChange'),
                    key: 'latestPlasmaChange',
                  },
                  {
                    title: fm('procedure.totalPlasmaChanges'),
                    value: plasmaChangeDocs.length,
                    key: 'plasmaChangeTotal',
                  },
                ]
              : []),
            ...(thymectomyDocs.length > 0
              ? [
                  {
                    value: isPartialDate(thymectomyDocs[0]?.date) ? formatPartialDate(thymectomyDocs[0].date) : '',
                    title: fm('procedure.latestThymectomy'),
                    key: 'latestThymectomy',
                  },
                  {
                    title: fm('procedure.totalThymectomies'),
                    value: thymectomyDocs.length,
                    key: 'thymectomyTotal',
                  },
                ]
              : []),
          ]}
        />
      </PlatformConditional>
      <PlatformConditional platform={'polyneuro'}>
        <TileContentMaker
          type="specificListNoDate"
          data={
            plasmaChangeDocs.length > 0
              ? [
                  {
                    value: isPartialDate(plasmaChangeDocs[0]?.date) ? formatPartialDate(plasmaChangeDocs[0].date) : '',
                    title: fm('procedure.latestPlasmaChange'),
                    key: 'latestPlasmaChange',
                  },
                  {
                    title: fm('procedure.totalPlasmaChanges'),
                    value: plasmaChangeDocs.length,
                    key: 'plasmaChangeTotal',
                  },
                ]
              : []
          }
        />
      </PlatformConditional>
    </>
  );
};

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<'procedure'>>;
}

export default ProceduresDash;
